const actions = {
  GET_KARIE_USERS: 'GET_KARIE_USERS',
  GET_KARIE_USERS_SUCCESS: 'GET_KARIE_USERS_SUCCESS',
  FETCH_KARIE_USER_INFO: 'FETCH_KARIE_USER_INFO',
  FETCH_KARIE_USER_ADHERENCE: 'FETCH_KARIE_USER_ADHERENCE',
  FETCH_KARIE_USER_ADHERENCE_SUCCESS: 'FETCH_KARIE_USER_ADHERENCE_SUCCESS',
  FETCH_KARIE_USER_MEDICATION: 'FETCH_KARIE_USER_MEDICATION',
  FETCH_KARIE_USER_MEDICATION_SUCCESS: 'FETCH_KARIE_USER_MEDICATION_SUCCESS',
  FETCH_KARIE_USER_INFO_SUCCESS: 'FETCH_KARIE_USER_INFO_SUCCESS',
  FETCH_KARIE_USER_INFO_ERROR: 'FETCH_KARIE_USER_INFO_ERROR',
  FETCH_KARIE_USER_RESPONSES: 'FETCH_KARIE_USER_RESPONSES',
  FETCH_KARIE_USER_RESPONSES_SUCCESS: 'FETCH_KARIE_USER_RESPONSES_SUCCESS',
  UN_ASSIGN_DEVICE: 'UN_ASSIGN_DEVICE',
  UN_ASSIGN_DEVICE_SUCCESS: 'UN_ASSIGN_DEVICE_SUCCESS',
  UN_ASSIGN_DEVICE_FAILURE: 'UN_ASSIGN_DEVICE_FAILURE',
  initData: () => ({type: actions.GET_KARIE_USERS}),
  fetchKarieUsers: () => ({
    type: actions.GET_KARIE_USERS
  }),
  fetchKarieUserInfo: (patientId) => ({
    type: actions.FETCH_KARIE_USER_INFO,
    patientId,
  }),
  fetchKarieUserAdherence: (patientId) => ({
    type: actions.FETCH_KARIE_USER_ADHERENCE,
    patientId,
  }),
  fetchKarieUserMedication: (patientId) => ({
    type: actions.FETCH_KARIE_USER_MEDICATION,
    patientId,
  }),
  fetchKarieUserResponses: (patientId, questionnaireId) => ({
    type: actions.FETCH_KARIE_USER_RESPONSES,
    patientId,
    questionnaireId,
  }),
  unassignDevice: (patientId, searchOptions ) => ({
    type: actions.UN_ASSIGN_DEVICE,
    patientId,
    searchOptions,
  }),
  unassignDeviceSuccess: () => ({
    type: actions.UN_ASSIGN_DEVICE_SUCCESS,
    payload: null,
  }),
  unassignDeviceFailure: (failureMessage) => ({
    type: actions.UN_ASSIGN_DEVICE_FAILURE,
    payload: {failureMessage},
  })
};
export default actions;
